// extracted by mini-css-extract-plugin
module.exports = {"Paper":"Form_Paper__o_WBP","Logout":"Form_Logout__3-fO2"};